<script>
  let { breadcrumb, children, footer } = $props()
</script>

<div class="flex flex-col flex-1 min-h-0">
  {#if breadcrumb}
    <div class="w-full bg-muted border-b border-border flex-shrink-0" style="view-transition-name: wizard-breadcrumb">
      <div class="max-w-5xl mx-auto px-4 sm:px-8 py-2">
        {@render breadcrumb()}
      </div>
    </div>
  {/if}

  <div class="flex-1 overflow-y-auto">
    <div class="max-w-5xl mx-auto p-4 sm:p-8 flex flex-col gap-4 sm:gap-6">
      {@render children()}
    </div>
  </div>

  {#if footer}
    <div class="w-full border-t border-border bg-background flex-shrink-0" style="view-transition-name: wizard-footer">
      <div class="max-w-5xl mx-auto px-4 sm:px-8 py-3 sm:py-4 flex items-center gap-3">
        {@render footer()}
      </div>
    </div>
  {/if}
</div>
